import { Grid, Typography, Container, Paper, Divider } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Controls
import { Select, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

import { Loading } from "@gpstrackit/react-controls";

//Helpers
import { HasPermission } from 'Core/security';
import { endpoints } from 'Core/defaultValues';
import { v4 as uuidv4 } from 'uuid';

//Views
import UploadImage from 'Modules/loginPage/main/.components/uploadImage';
import CreateEditTemplate from 'Modules/loginPage/main/.components/createEditTemplate';
import ConfirmSave from 'Modules/loginPage/main/.components/confirmSave';
import ConfirmTemplate from 'Modules/loginPage/main/.components/confirmTemplate';

import SunEditor from 'suneditor-react';
import 'suneditor/src/assets/css/suneditor.css'

//Actions
import {
    cloudLoginPageSaveLoginPageRequest,
    cloudLoginPageGetTemplateRequest,
    cloudLoginPageConfirmToSaveOpenModal,
    cloudLoginPageConfirmTemplateOpenModal,
    cloudLoginPageGetTemplateResult,
    templateSearchRequest,
    templateOpenModal,
    imagesOpenModal,
    clearRedux,
} from 'Redux/actions';

//Styles
import './index.scss'

const LoginPageMain = (props) => {
    const dispatch = useDispatch();
    const newEditor = useRef(null);
    const isLoadingContent = useRef(false);
    const { messages } = useIntl();

    const [language, setLanguage] = useState({
        id: 1,
        label: messages['login_page_english']
    });
    const [value, setValue] = useState("");
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [newTemplate, setNewTemplate] = useState(null);
    const [currentTemplate, setCurrentTemplate] = useState(false);
    const [temporalLanguage, setTemporalLanguage] = useState(null);
    const [temporalTemplate, setTemporalTemplate] = useState(null);
    const [temporalValue, setTemporalValue] = useState(null);

    const { templates } = useSelector(state => state.createEditTemplateRedux);
    const loadingTemplate = useSelector(state => state.createEditTemplateRedux.loading);
    const { saveContentResponse, loading, loginPage, confirmToSave, confirmTemplate } = useSelector(state => state.loginPageMainRedux);
    const openModalTemplate = useSelector(state => state.createEditTemplateRedux.openModal);
    const openModalImage = useSelector(state => state.cloudLoginPageUploadImageRedux.openModal);
    const lang = useSelector(state => state.commonRedux.language);
    const { user } = useSelector(state => state.securityRedux);

    const resetLanguage = (lan) => {
        if (lan?.id) dispatch(templateSearchRequest(lan.id));
        else dispatch(clearRedux("TEMPLATES", { templates: [] }));
        setValue('');
        setSelectedTemplate(null);
        setLanguage(lan)
        let currentLanguage = lan?.id === 1 ? 'EN' : 'ES'
        dispatch(cloudLoginPageGetTemplateRequest({ language: currentLanguage }))
    }

    const resetTemplate = (temp) => {
        setSelectedTemplate(temp)
        setValue('');
        setTemporalValue(temp)
    }

    const handlerLanguage = (lan) => {
        if (currentTemplate) {
            setTemporalLanguage(lan)
            dispatch(cloudLoginPageConfirmTemplateOpenModal(true))
        } else resetLanguage(lan)
    }

    const handlerTemplate = (temp) => {
        if (currentTemplate) {
            setTemporalTemplate(temp)
            dispatch(cloudLoginPageConfirmTemplateOpenModal(true))
        } else resetTemplate(temp)
    }

    useEffect(() => {
        if (temporalValue) {
            dispatch(cloudLoginPageGetTemplateResult(temporalValue?.html))
            setTemporalValue(null)
        }
    }, [temporalValue])

    useEffect(() => {
        if (saveContentResponse) {
            NotificationManager.success(
                messages[saveContentResponse.message],
                messages['login_page_title'],
                3000
            );
            if (saveContentResponse?.preview) {
                window.open(`${endpoints.CLOUD_WEBSITE}/login/preview/${newTemplate}`, "_blank");
                setNewTemplate(null)
            } else setCurrentTemplate(false);
            dispatch(clearRedux("CLOUDLOGINPAGE_UPLOAD_IMAGE", { saveContentResponse: null }))
        }

        if (loginPage) {
            isLoadingContent.current = true;
            setValue(loginPage);
            setTimeout(() => { isLoadingContent.current = false; }, 500);
        }

        if (templates && templates.length > 0) {
            if (selectedTemplate) {
                let newValue = templates.find((item) => item?.id === selectedTemplate?.id)
                if (newValue) setSelectedTemplate(newValue)
                else {
                    setSelectedTemplate(null)
                    setValue(null);
                }
            }
        }
        if (confirmToSave) {
            dispatch(clearRedux("CLOUDLOGINPAGE_UPLOAD_IMAGE", { confirmToSave: false, confirmToSaveOpenModal: false }))
            let content = (value !== '<p><br></p>') ? value : ''
            let currentLanguage = language?.id === 1 ? 'EN' : 'ES'
            dispatch(cloudLoginPageSaveLoginPageRequest("", false, content, currentLanguage))
        }
        if (confirmTemplate) {
            if (temporalLanguage) {
                resetLanguage(temporalLanguage)
                setTemporalLanguage(false);
            }
            if (temporalTemplate) {
                resetTemplate(temporalTemplate);
                setTemporalTemplate(false);
            }
            dispatch(clearRedux("CLOUDLOGINPAGE_UPLOAD_IMAGE", { confirmTemplate: false }))
        }
    }, [saveContentResponse, loginPage, templates, confirmToSave, confirmTemplate])

    const getSunEditorInstance = (sunEditor) => {
        newEditor.current = sunEditor;
    };

    useEffect(() => {
        const insertImage = document.querySelectorAll('.insert-image');
        const handlerTemplate = document.querySelectorAll('.handler-template');
        
        if (lang) {
            let payload = {
                id: language.id,
                label: language.id == 1 ? messages['login_page_english'] : messages['login_page_spanish']
            }
            setLanguage(payload)
        }

        try {
            insertImage[0].childNodes[1].innerHTML = `<span class='se-tooltip-inner'><span class='se-tooltip-text'>${messages['login_page_insert_image']}</span></span>`;
            handlerTemplate[0].childNodes[1].innerHTML = `<span class='se-tooltip-inner'><span class='se-tooltip-text'>${messages['login_page_create_edit_template']}</span></span>`;
        } catch (error) { }

        insertImage.forEach((item) => {
            item.addEventListener('click', () => dispatch(imagesOpenModal(true)));
        });
        
        handlerTemplate.forEach(item => {
            item.addEventListener('click', () => dispatch(templateOpenModal(true)));
        });

    }, [lang])

    useEffect(() => {
        if (value && value !== "<p><br></p>") {
            if (loginPage) dispatch(clearRedux("CLOUDLOGINPAGE_UPLOAD_IMAGE", { loginPage: null }))
            else if (!isLoadingContent?.current) setCurrentTemplate(true)
        }
    }, [value])

    useEffect(() => {
        let currentLanguage = language?.id === 1 ? 'EN' : 'ES'
        dispatch(cloudLoginPageGetTemplateRequest({ language: currentLanguage }))
        dispatch(templateSearchRequest(language.id));
    }, [])

    return (
        <Container maxWidth={false} className="container-view">
            {loading && <Loading show overlay />}
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Grid item xs={6}>
                        <Typography variant="h5" gutterBottom component="div">
                            {messages['login_page_title']}
                        </Typography>
                    </Grid>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <Grid
                        container
                        spacing={1}
                        style={{
                            backgroundColor: '#fafafa',
                            margin: 0,
                            border: '1px solid #dadada',
                            borderBottom: 0
                        }}
                    >
                        <Grid item xs={12}>
                            <div className="search-toolbar-cloud-login-page" >
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: 200, marginRight: 5 }}>
                                        <Select
                                            id="editor-language"
                                            placeholder={messages['login_page_language']}
                                            value={language}
                                            onChange={handlerLanguage}
                                            options={[
                                                {
                                                    id: 1,
                                                    label: messages['login_page_english']
                                                },
                                                {
                                                    id: 2,
                                                    label: messages['login_page_spanish']
                                                }
                                            ]}
                                            textField="label"
                                            valueField="id"
                                            loading={loadingTemplate}
                                        />
                                    </div>
                                    <div style={{ width: 200 }}>
                                        <Select
                                            id="editor-templates"
                                            placeholder={messages['login_page_templates']}
                                            value={selectedTemplate}
                                            onChange={handlerTemplate}
                                            options={templates || []}
                                            textField="name"
                                            valueField="id"
                                            loading={loadingTemplate}
                                            isClearable
                                        />
                                    </div>
                                </div>
                                <div>
                                    <Button
                                        style={{ padding: 5, height: 30 }}
                                        className="btn-blue"
                                        disabled={!language || loading || !HasPermission(user, "lgnpage", "c")}
                                        onClick={() => {
                                            dispatch(cloudLoginPageConfirmToSaveOpenModal(true))
                                        }}
                                    >
                                        {messages['login_page_save']}
                                    </Button>
                                    <Button
                                        style={{ padding: 5, height: 30 }}
                                        className="btn-dark-blue"
                                        disabled={!value || loading || !HasPermission(user, "lgnpage")}
                                        onClick={() => {
                                            let tempName = uuidv4();
                                            setNewTemplate(tempName)
                                            let currentLanguage = language?.id === 1 ? 'EN' : 'ES'
                                            dispatch(cloudLoginPageSaveLoginPageRequest(`${tempName}.htm`, true, value, currentLanguage))
                                        }}
                                    >
                                        {messages['login_page_preview']}
                                    </Button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <SunEditor
                            lang={lang}
                            setContents={value}
                            onChange={setValue}
                            getSunEditorInstance={getSunEditorInstance}
                            height="calc(100vh - 280px)"
                            setOptions={{
                                height: "100%",
                                attributesWhitelist: {
                                    'all': 'style|data-.+'
                                },
                                buttonList: [
                                    ["bold",
                                        "underline",
                                        "italic",
                                        "strike",
                                        "subscript",
                                        "superscript",
                                        "fontColor",
                                        "hiliteColor",
                                        "textStyle",
                                        "removeFormat",
                                        "outdent",
                                        "align",
                                        "indent",
                                        "list",
                                        "fontSize",
                                        "formatBlock",
                                        "link",
                                        "table",
                                        "video",
                                        "codeView",
                                        "showBlocks"
                                    ],
                                    [
                                        {
                                            name: "insert-image",
                                            title: "Insert Image",
                                            buttonClass: "insert-image",
                                            innerHTML: `<span class="material-icons MuiIcon-root toolbar-list-icon fs-20" aria-hidden="true" style="cursor: pointer; font-size: 20px; opacity: 0.7; padding-left: 7px;">image</span>`,
                                        },
                                        {
                                            name: "handler-template",
                                            title: "Create/Edit Template",
                                            buttonClass: "handler-template",
                                            innerHTML: `<span class="material-icons MuiIcon-root toolbar-list-icon fs-20" aria-hidden="true" style="cursor: pointer; font-size: 20px; opacity: 0.7">save</span>`
                                        }
                                    ]
                                ]
                            }}
                        />
                    </Grid>
                </Grid>
            </Paper>
            {openModalImage && <UploadImage editor={newEditor} />}
            {
                openModalTemplate &&
                <CreateEditTemplate
                    selectedTemplate={selectedTemplate}
                    language={language}
                    html={value}
                    setCurrentTemplate={setCurrentTemplate}
                />
            }
            <ConfirmSave language={language} />
            <ConfirmTemplate />
        </Container >
    )
}
export default LoginPageMain;